// Bloom: de 'Afrekenen met iDEAL'-knop legt het gekozen e-book in het mandje en
// stuurt de klant meteen door naar de checkout.
//
// De knop is een echte link naar een cart-permalink, dus zonder JavaScript werkt
// hij ook. Deze module vangt de klik af om de op dat moment gekozen variant en
// het aantal mee te nemen: de permalink in de href kent alleen de variant die bij
// het laden van de pagina geselecteerd was.

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest('[data-bloom-ideal-checkout]');
  if (!button) return;

  const form = button.closest('form[action*="/cart/add"]');
  const variantId = form?.querySelector('[name="id"]')?.value;

  // Geen formulier of variant gevonden: laat de browser de href gewoon volgen.
  if (!variantId) return;

  event.preventDefault();

  if (button.dataset.bloomBusy === 'true') return;
  button.dataset.bloomBusy = 'true';
  button.setAttribute('aria-busy', 'true');

  const quantityValue = form.querySelector('[name="quantity"]')?.value;
  const quantity = Math.max(1, Number.parseInt(quantityValue, 10) || 1);
  const root = window.Shopify?.routes?.root || '/';

  fetch(`${root}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] }),
  })
    .then((response) => {
      if (!response.ok) throw new Error('Toevoegen aan winkelwagen mislukt');
      window.location.assign(`${root}checkout`);
    })
    .catch(() => {
      // Val terug op de permalink in de href zodat de klant hoe dan ook verder kan.
      button.dataset.bloomBusy = 'false';
      button.removeAttribute('aria-busy');
      window.location.assign(button.getAttribute('href') || `${root}cart`);
    });
});
